import type { QueryFunctionContext } from '@tanstack/react-query';

import { handleRequest } from '@/lib/api/factories/base-api-factory';
import bookingInstance from '@/lib/axios/booking-instance';
import type { IBaseResponse } from '@/types/base-response';

import type { Client } from '../../console.types';

/**
 * Tenant registry. Every route behind `/company` is super-Admin only — a
 * company is the boundary the rest of the CMS is scoped by, so listing or
 * creating one is deliberately kept outside a tenant's own reach.
 */

/** GET /company — paginated, filterable by name and status. */
const getClients = ({
  queryKey,
}: QueryFunctionContext): Promise<IBaseResponse<Client.IClient[]>> =>
  handleRequest(bookingInstance.get('/company', { params: queryKey[1] }));

/** GET /company/:id */
const getClient = ({
  queryKey,
}: QueryFunctionContext): Promise<IBaseResponse<Client.IClient>> =>
  handleRequest(bookingInstance.get(`/company/${queryKey[1] as string}`));

/** POST /company */
const createClient = (payload: Client.ICreateClient) =>
  handleRequest<IBaseResponse<Client.IClient>>(
    bookingInstance.post('/company', payload)
  );

/** PUT /company/:id — partial; only the fields sent are written. */
const updateClient = ({
  id,
  payload,
}: {
  id: string;
  payload: Client.IUpdateClient;
}) =>
  handleRequest<IBaseResponse<Client.IClient>>(
    bookingInstance.put(`/company/${id}`, payload)
  );

export const ClientsService = {
  getClients,
  getClient,
  createClient,
  updateClient,
};
